import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import Env from '@ridango/core/env';
import { Observable } from 'rxjs';

interface HtmlStopScheduleDTO {
    stopId: string;
    routeId: string;
    patternId?: string;
    date?: string;
}

@Injectable()
export class PrintScheduleService {
    constructor(
        @Inject('ENV') public env: Env,
        private http: HttpClient,
        private translate: TranslateService
    ) {}

    getHtmlStopSchedule(payload: HtmlStopScheduleDTO): Observable<any> {
        const url = `${this.env.WMB?.WMB_PUBLIC_API}/v1/timetable/stop-schedule`;
        const [, routeIdWithoutPrefix] = payload.routeId.split(':');
        const [, stopIdWithoutPrefix] = payload.stopId.split(':');

        const headers = new HttpHeaders().set('Content-Type', 'text/html');

        let params = new HttpParams()
            .set('stopId', stopIdWithoutPrefix)
            .set('routeId', routeIdWithoutPrefix)
            .set('locale', this.translate.currentLang)
            .set('regionId', this.env.REGION_ID);

        if (payload.patternId) {
            const parts = payload.patternId.split(':');
            const patternIdWithoutPrefix = parts.length > 1 ? parts.slice(1).join(':') : payload.patternId;
            params = params.set('patternId', patternIdWithoutPrefix);
        }
        if (payload.date) {
            params = params.set('date', payload.date);
        }

        return this.http.get(url, { headers, params, responseType: 'text' });
    }

    printHTML(html: string) {
        const printStyle = `
        <style>
            @page { size: landscape; margin: 1cm; }

            body { margin: 0; padding: 0; }
            h1.route-number { break-after: avoid; }
            h2 { break-after: avoid; margin-bottom: 8px; }

            .schedule-container {
                display: flex;
                flex-wrap: wrap;
                gap: 12px;
                align-items: flex-start;
            }
            .schedule-column {
                flex: 0 0 auto;
                margin-right: 0;
                margin-bottom: 16px;
                break-inside: avoid;
                page-break-inside: avoid;
            }
            .schedule-column-title { font-size: 11px; }
            .schedule-row-hours { font-size: 13px; width: 28px; height: 22px; }
            .schedule-row-minutes { font-size: 12px; width: 22px; height: 22px; }
        </style>
    `;

        const htmlWithStyle = html.includes('</head>')
            ? html.replace('</head>', `${printStyle}</head>`)
            : printStyle + html;

        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        document.body.appendChild(iframe);

        const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
        iframeDoc.write(htmlWithStyle);
        iframeDoc.close();

        iframe.contentWindow.print();
    }
}
